import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Header = ({ data }) => {
  const { logo } = data;

  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Use useEffect to check screen size for mobile view
  useEffect(() => {
    const updateMobileView = () => {
      setIsMobile(window.innerWidth <= 768); // You can adjust this breakpoint if needed
    };

    updateMobileView(); // Check on initial load
    window.addEventListener("resize", updateMobileView); // Check on window resize

    return () => {
      window.removeEventListener("resize", updateMobileView);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const windowTop = window.scrollY || document.documentElement.scrollTop;

      if (windowTop >= headerHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      setLastScrollTop(windowTop);
    };

    const headerHeight =
      document.querySelector(".st-sticky-header").offsetHeight + 100;

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSticky, lastScrollTop]);

  return (
    <header
      className={`st-site-header st-style1 st-sticky-header ${
        isSticky ? "st-sticky-active" : ""
      }`}
    >
      <div className="st-main-header">
        <div className="container">
          <div className="st-main-header-in">
            <div className="st-main-header-left">
              <Link to="" className="st-site-branding">
                <img src={logo} alt="Logo" />
              </Link>
            </div>
            <div className="st-main-header-right">
              <div className="st-nav">
                {/* Login Button Always Visible */}
                <a
                  href="https://dotor.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="st-btn st-style1 st-size-medium st-color1 st-smooth-move"
                >
                  {isMobile ? "Back to App" : "Login"}{" "}
                  {/* Conditionally change text */}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
